export const DateFormat = function (datetime, formatStr) {
  var dat = datetime;
  var str = formatStr;
  var Week = ['日', '一', '二', '三', '四', '五', '六'];
  str = str.replace(/yyyy|YYYY/, dat.getFullYear());
  str = str.replace(/yy|YY/, dat.getYear() % 100 > 9 ? (dat.getYear() % 100).toString() : '0' + (dat.getYear() % 100));
  str = str.replace(/MM/, dat.getMonth() >= 9 ? (dat.getMonth() + 1).toString() : '0' + (dat.getMonth() + 1));
  str = str.replace(/M/g, dat.getMonth() + 1);
  str = str.replace(/w|W/g, '星期'+ Week[dat.getDay()]);
  str = str.replace(/dd|DD/, dat.getDate() > 9 ? dat.getDate().toString() : '0' + dat.getDate());
  str = str.replace(/d|D/g, dat.getDate());
  str = str.replace(/hh|HH/, dat.getHours() > 9 ? dat.getHours().toString() : '0' + dat.getHours());
  str = str.replace(/h|H/g, dat.getHours());
  str = str.replace(/mm/, dat.getMinutes() > 9 ? dat.getMinutes().toString() : '0' + dat.getMinutes());
  str = str.replace(/m/g, dat.getMinutes());
  str = str.replace(/ss|SS/, dat.getSeconds() > 9 ? dat.getSeconds().toString() : '0' + dat.getSeconds());
  str = str.replace(/s|S/g, dat.getSeconds());
  return str;
};

// 时间戳转换成响应格式的日期时间
export const newDateFormat = (type, val) => {
  if (!val) {
    return '';
  }
  const date = new Date(/^[0-9]*$/g.test(val) ? Number(val) : val);
  const YYYY = String(date.getFullYear());
  const YY = String(date.getFullYear()).substr(2);
  const m = date.getMonth() + 1;
  const MM = m > 9 ? String(m) : '0' + m;
  const d = date.getDate();
  const DD = d > 9 ? String(d) : '0' + d;
  const h = date.getHours();
  const hh = h > 9 ? String(h) : '0' + h;
  const $m = date.getMinutes();
  const mm = $m > 9 ? String($m) : '0' + $m;
  const s = date.getSeconds();
  const ss = s > 9 ? String(s) : '0' + s;
  const obj = { YYYY, YY, MM, DD, hh, mm, ss };
  return type.replace(/(YYYY)|(YY)|(MM)|(DD)|(hh)|(mm)|(ss)/g, (key) => obj[key]);
};

export const getMonthDays = (year, month) => {
  var stratDate = new Date(year, month - 1, 1),
    endData = new Date(year, month, 1);
  var days = (endData - stratDate) / (1000 * 60 * 60 * 24);
  var list = [];
  for (var i = 1; i <= days; i++) {
    // const d = i > 9 ? i : '0'+i
    const d = i;
    const day = month + '-' + d;
    const week =
      new Date(month + '/' + i + '/' + year).getDay() == 0
        ? '日'
        : new Date(month + '/' + i + '/' + year).getDay() == 1
        ? '一'
        : new Date(month + '/' + i + '/' + year).getDay() == 2
        ? '二'
        : new Date(month + '/' + i + '/' + year).getDay() == 3
        ? '三'
        : new Date(month + '/' + i + '/' + year).getDay() == 4
        ? '四'
        : new Date(month + '/' + i + '/' + year).getDay() == 5
        ? '五'
        : new Date(month + '/' + i + '/' + year).getDay() == 6
        ? '六'
        : '';
    list.push({
      day,
      week,
      d,
    });
  }
  return list;
};
//获取当月天数

export const getDaysInMonth = (year, month) => {
  month = parseInt(month, 10); //parseInt(number,type)这个函数后面如果不跟第2个参数来表示进制的话，默认是10进制。
  var temp = new Date(year, month, 0);
  let n = +temp.getDate();
  let dataTimes = [];
  for (var i = 1; i < n + 1; i++) {
    dataTimes.push(i);
  }
  return dataTimes.length; //dataTimes.length
};
export const formatDate = (date, format) => {
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 小时
    'H+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
    a: date.getHours() < 12 ? '上午' : '下午', // 上午/下午
    A: date.getHours() < 12 ? 'AM' : 'PM', // AM/PM
  };
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return format;
};

export default {
  timeChange(m) {
    return m < 10 ? '0' + m : m;
  },
  format(date) {
    let time = new Date(date);
    let y = time.getFullYear();
    let m = time.getMonth() + 1;
    let d = time.getDate();
    let h = time.getHours();
    let mm = time.getMinutes();
    let s = time.getSeconds();
    return (
      y +
      '-' +
      this.timeChange(m) +
      '-' +
      this.timeChange(d) +
      ' ' +
      this.timeChange(h) +
      ':' +
      this.timeChange(mm) +
      ':' +
      this.timeChange(s)
    );
  },
};
